import SceneObject from "../../../lib/services/scene/sceneobject";
import ShaderService from "../../../lib/services/shader/shader_service";
import Camera from "../../../lib/services/scene/camera";
import ResourceService from "../../../lib/services/resource/resourceservice";
import PlaneAlphaRenderPipeline from "../../../lib/services/render/pipelines/plane_alpha_renderpipeline";

export default class Haze extends SceneObject {
  pipeline: PlaneAlphaRenderPipeline;

  constructor(key: string,x: number) {
    super(key);
    this.pipeline = new PlaneAlphaRenderPipeline(
      "haze",
      "unlit_no_discard", // alpha-blend version, NOT the discard one
      "haze",
      1, 1
    );

    this.transform.set_position(x,0.28262075781822205,-4.593911170959473);
    this.transform.set_rotation(Math.PI * 0.5, 0, 0);
    this.transform.set_scale(1, 1, 1);
    this.transform.update_matrix();
  }


   
  async build(device: GPUDevice,format: GPUTextureFormat, shader_service: ShaderService,resource_service: ResourceService): Promise<void> 
  
  {
    await this.pipeline.build(device, format, shader_service, resource_service);
  }

   tick(delta_time: number): void 
    {
       //this.placement.tick(delta_time);
    }
  
    prepare(device: GPUDevice, camera: Camera): void 
    {
          this.pipeline.prepare(device, camera, this.transform);
       
    }
    
    draw(pass: GPURenderPassEncoder): void 
    {
       this.pipeline.draw(pass);
    }
     
  }
